"use client"

import styled from "@emotion/styled"
import { Contact } from "../Home/Contact/Contact"

const ContactPageWrapper = styled.div`
  display: flex;
`

export const ContactPage = () => {
  return (
    <ContactPageWrapper>
      <Contact />
    </ContactPageWrapper>
  )
}
